import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navigation from './components/Navigation';
import About from './pages/About';
import MapPage from './pages/MapPage';
import SharedMapPage from './pages/SharedMapPage';
import './App.css';

function AppContent() {
  const location = useLocation();
  const isMapPage = location.pathname === '/map' || location.pathname === '/map/demo';
  const isSharedMapPage = location.pathname.startsWith('/shared/');

  return (
    <div className="app">
      {!isMapPage && !isSharedMapPage && <Navigation />}
      <Routes>
        <Route path="/" element={<About />} />
        <Route path="/map" element={<MapPage />} />
        <Route path="/map/demo" element={<MapPage />} />
        <Route path="/shared/:shareId" element={<SharedMapPage />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App; 